import { test, both, allPass, compose } from 'ramda'
import { notEmpty } from 'shared/helpers/functional'

const withError = (error, f) => compose(isValid => ({ isValid, error: isValid ? '' : error }), f)
export const validatePassword = allPass([test(/^.{7,32}$/), test(/[0-9]+/), notEmpty])
export const validateEmail = both(test(/^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}\s*$/), notEmpty)
export const validatePasswordWithError = withError('Please enter a valid password. It must be between 7 and 32 characters and contain at least one digit.', validatePassword)
export const validateEmailWithError = withError('Please enter a valid email address', validateEmail)

export const validateSurveyId = allPass([test(/^.{6,10}$/), test(/^[0-9]*$/), notEmpty])
export const validateSurveyIdWithError = withError('error',validateSurveyId)

export const validateLink = allPass([test(/^\S*$/), notEmpty])
export const validateLinkWithError = withError('error',validateLink)

export const validateURL = (link) => {
  if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
    return true
  } else {
    return false
  }
}

const validated = (validAndErrorObj, value) => {
  validAndErrorObj.value = value
  return validAndErrorObj
}

export function validate (f, a) {
  return validated(f(a), a)
}
